import Swiper from "swiper";
import { Pagination } from "swiper/modules";

const DEBUG = false;
const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[FeaturedCollectionsSwiper] ${message}`, payload ?? "");
  },
};

export function initFeaturedCollectionsSwipers(root = document) {
  root.querySelectorAll("[data-featured-collections-swiper]").forEach(initOne);
}

function initOne(el) {
  // garde-fou maison (pas swiper-initialized)
  if (el.__swiper) return;

  const pagination = el
    .closest(".featured-collections")
    ?.querySelector(".featured-collections-pagination");

  logger.info("init");

  el.__swiper = new Swiper(el, {
    modules: [Pagination],
    slidesPerView: 1.5,
    spaceBetween: 16,
    slidesOffsetAfter: 16,
    slidesOffsetBefore: 16,
    loop: false,
    threshold: 12,
    grabCursor: true,
    pagination: pagination
      ? {
          el: pagination,
          clickable: true,
        }
      : undefined,
  });
}

initFeaturedCollectionsSwipers();
